// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__1gppS","triangle":"style_triangle__3O7ic","popover":"style_popover__20V3L","worldIcon":"style_worldIcon__6SrAJ"};